define('bundles/common-ui',['require'],function(require) {

  function coreDependencies(callback) {
    // Core dependencies, that needs to be loaded before the rest

    require([
      'lib/prototype/Function.prototype',
      'lib/prototype/String.prototype',
      'lib/prototype/Array.prototype',
      'underscore',
      'jquery',
      'jquery-ui',
      'lib/jquery/jquery-ui-patches',
      'translate',
      'lib/Podio.Locale',
      'lib/Podio.Bootstrap',
      'lib/Podio.Config'
    ], function() {
      loadCommonDependencies(callback);
    });

  }

  function loadCommonDependencies(callback) {
    // Common dependencies, that's is here to get bundled up in this file

    require([
      'backbone', 'backbone-super', 'jsx', 'react', 'react-backbone',
      'lib/Podio.UI',
      'lib/Podio.Event.UI',
      'lib/Podio.Store',
      'lib/Podio.Transport',
      'lib/Podio.Utils.Text',
      'lib/Podio.Viewport',
      'lib/Podio.Push',
      'lib/Podio.Favicon',
      'lib/Podio.Viewport',
      'lib/Podio.FormValidation',
      'lib/Podio.Router',
      'lib/Podio.Routes',
      'lib/Podio.SingleSignOn',
      'lib/Podio.Tracking',
      'lib/Podio.Tracking.Pendo',
      'lib/Podio.Tracking.Pendo.Search',
      'lib/Podio.PageVisibility',
      // Backbone
      'lib/backbone/Backbone.PodioOverrides',
      'lib/backbone/Backbone.PodioEvents',
      'lib/backbone/Backbone.ChildViewContainer',
      'lib/backbone/Backbone.Mixins.Transport',
      'lib/backbone/Backbone.Validators',
      'lib/backbone/Backbone.PodioModel',
      'lib/backbone/Backbone.PodioCollection',
      'lib/backbone/Backbone.PodioPaginatedCollection',
      'lib/backbone/Backbone.PodioCachedCollection',
      'lib/backbone/Backbone.PodioScrollPaginatedCollection',
      'lib/backbone/Backbone.PodioOffsetPaginatedCollection',

      'lib/backbone/Backbone.PodioView',
      'lib/backbone/Backbone.PodioPaginatedView',
      'lib/backbone/Backbone.PodioScrollPaginatedView',
      'lib/backbone/Backbone.PodioCollectionView',
      'lib/backbone/Backbone.PodioPaginatedCollectionView',
      'lib/backbone/Backbone.PodioRouter',
      'lib/backbone/Backbone.PodioController',
      'lib/backbone/Backbone.Mixins.StateMachine',

      // jQuery
      'lib/jquery/jquery.events.txtInput',
      'jquery-mousewheel',
      'lib/jquery/jquery.ba-outside-events',
      'lib/jquery/jquery.elastic',
      'lib/jquery/jquery.getscrollbarwidth',
      'lib/jquery/jquery.podioDropdown',
      'lib/jquery/jquery.hotkeys',
      'lib/jquery/jquery.podiopicker',
      'lib/jquery/jquery.timeentry',

      'lib/jquery/jquery.dropdown-component',

    // UI
      'lib/Podio.UI.FormEmbedActions',
      'lib/Podio.UI.Reminder',
      'lib/Podio.UI.DelayedContent',
      'lib/Podio.UI.SharedFiles',
      'lib/Podio.UI.Closable',
      'lib/Podio.UI.Embeds',
      'lib/Podio.UI.Questions',
      'lib/Podio.UI.Presence',
      'lib/Podio.UI.Form',
      'lib/Podio.UI.Balloon.AutoShow',
      'lib/Podio.UI.Dropdowns',
      'lib/Podio.UI.Timestamps',
      'lib/Podio.UI.PushNotifications',
      'lib/Podio.UI.FlashMessage',
      'lib/Podio.UI.Lightbox',
      'lib/Podio.UI.FileFinder',
      'lib/Podio.UI.Tooltips',
      'lib/Podio.UI.SimpleBalloon',
      'lib/Podio.UI.DynamicContent',
      'lib/Podio.DebugGrid',
      'lib/Podio.UI.Video',

      // Common views
      'views/lib/Podio.Views.ProvidersMatrix',
      'views/lib/Podio.Views.AccountsSettingsDropdown',
      'views/lib/Podio.Views.SideTabsLayout',
      'views/lib/Podio.Views.SideTabsBadgeCount',
      'views/lib/Podio.Views.SubmitToggler',
      'views/lib/Podio.Views.SlotMachineCount',
      'views/lib/Podio.Views.SideTabsLinkedAccountsLayout',

      // FileUploader
      'lib/fileuploader/base',
      'lib/fileuploader/multi',
      'lib/fileuploader/single',
      'lib/fileuploader/avatar',

      // Filefinder
      'lib/Podio.UI.FileFinder',

      // SpaceContacts
      'root/contacts/Podio.SpaceContacts',

      // Reccurence
      'lib/Podio.UI.Recurrence',

      // People Finder
      'controllers/peoplefinder/Podio.Controllers.PeopleFinder.Main',

      // People Picker
      'lib/Podio.UI.PeoplePicker',

      // MentionsInput
      'lib/Podio.Transport.Mentions',
      'lib/mentionsinput/PodioMentionsInput',
     // Left nav
      'controllers/leftnav/Podio.Controllers.LeftNav.Main',
      'lib/Podio.UI.LeftNavigation',

      // Space switcher
      'controllers/Podio.Controllers.SpaceSwitcher',

      // Presence bar
      'controllers/presence/Podio.Controllers.PresenceBar',

      // Conversations
      'controllers/conversations/Podio.Controllers.Conversations.New',

      // Space invitations
      'lib/Podio.UI.SpaceInvitations.New',

      // Chat pane
      'controllers/conversations/Podio.Controllers.Conversations.Chat',

      // Task modal (for hotkey)
      'lib/Podio.UI.Tasks.Create',

      // Header
      'lib/Podio.UI.Header',

      // Unroll me
      'lib/Podio.UI.Subscriptions',

      // Addressbook
      'controllers/address_book_export/Podio.Controllers.AddbookExport.Main',

      // Comments
      'root/Podio.Comments',

      // Unsupported browser
      'controllers/Podio.Controllers.UnsupportedBrowser',

      // Organizations
      'lib/Podio.Organizations.Setup',
      'lib/Podio.Organizations.Create',

      // Upgrade
      'sections/upgrade/Podio.UI.Upgrade.Global',

      // Search
      'lib/Podio.UI.SearchInput',

      // View helpers
      'lib/view_helpers/base',
      'lib/view_helpers/time',
      'lib/view_helpers/apps',
      'lib/view_helpers/appFilterFormatter',

      // Podio Academy
      'lib/Podio.Academy'

    ], function() {

      initializeComponents();
      callback();

    });

  }

  function initializeComponents() {
    require(['controllers/Podio.Controllers.Navigation'], function(SpaceNavigationController) {
      new SpaceNavigationController();
    });
  }

  return {
    init: coreDependencies
  };

});

